module.exports = __webpack_public_path__ + "img/a_manger.191776ad.png";